import { replaceQuotes } from '../../utils/helpers';

export const PATHWAY_PAGE_CUSTOM_BLOCKS_URL = '/pathways/';

export type Test = {
  id?: string;
  title?: string | null;
  canPassTest: boolean;
  testPassed: boolean;
};

export const getPathwayPageJsonData = (
  title = '',
  description = '',
  cpdCredits: string | null = '',
) => {
  const _title = replaceQuotes(title);
  const _description = replaceQuotes(description);

  return `{
    "@context": "https://schema.org",
    "@type": "Course",
    "name": "${_title}",
    "description": "${_description}",
    "teaches": "${_description}",
    ${cpdCredits ? '"numberOfCredits": ' + cpdCredits + ',' : ''}
    "author": {
        "@type": "Organization",
        "name": "Finance Unlocked",
        "sameAs": "https://financeunlocked.com"
    },
    "provider": {
        "@type": "Organization",
        "name": "Finance Unlocked",
        "sameAs": "https://financeunlocked.com"
    },
    "learningResourceType": "video",
    "isAccessibleForFree": "False"
  }`;
};
